import {IconProps} from './types'

export default function GreyIcon({size = 16, ...props}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clip-path="url(#clip0_5_29767)">
        <path
          d="M8 1.33337V2.66671"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.28667 3.28662L4.22667 4.22662"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.3333 8H14.6667"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.7133 3.28662L11.7733 4.22662"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.6313 8.43329C10.7134 7.93629 10.653 7.42622 10.4571 6.96213C10.2613 6.49803 9.93798 6.0989 9.52467 5.81095C9.11137 5.52299 8.62495 5.35799 8.12175 5.33504C7.61854 5.3121 7.11913 5.43215 6.68133 5.68129"
          stroke="#F8971D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.66667 14.6667H4.66667C4.03598 14.6665 3.41827 14.4875 2.88528 14.1503C2.35229 13.8131 1.9259 13.3317 1.65562 12.7618C1.38534 12.192 1.28227 11.5572 1.35837 10.9311C1.43448 10.305 1.68664 9.71337 2.08557 9.22489C2.4845 8.7364 3.01383 8.37111 3.61208 8.17145C4.21033 7.97178 4.85294 7.94594 5.46529 8.09692C6.07764 8.24789 6.6346 8.5695 7.07147 9.02437C7.50834 9.47924 7.8072 10.0487 7.93333 10.6667H8.66667C9.1971 10.6667 9.70581 10.8774 10.0809 11.2525C10.456 11.6275 10.6667 12.1362 10.6667 12.6667C10.6667 13.1971 10.456 13.7058 10.0809 14.0809C9.70581 14.456 9.1971 14.6667 8.66667 14.6667Z"
          stroke="#6D6D6D"
          stroke-width="1.33333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_29767">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
